var map = {
	"./icons/Capacity.svg": "c6d8",
	"./icons/Risk.svg": "a31c",
	"./icons/Risk2.svg": "cb16",
	"./icons/TransactionData.svg": "d339",
	"./icons/TransactionData1.svg": "0e82",
	"./icons/activities.svg": "7a7c",
	"./icons/activities2.svg": "92e8",
	"./icons/bar-chart.svg": "bde4",
	"./icons/budget.svg": "f6d3",
	"./icons/budget2.svg": "378c",
	"./icons/budget3.svg": "6ab3",
	"./icons/commitment.svg": "f7b0",
	"./icons/commitment2.svg": "3cd7",
	"./icons/dates.svg": "8cd5",
	"./icons/dates2.svg": "1d7c",
	"./icons/equipment.svg": "3814",
	"./icons/equipment2.svg": "6638",
	"./icons/estimates.svg": "446f",
	"./icons/estimates2.svg": "f267",
	"./icons/estimates3.svg": "ad29",
	"./icons/fa-chart-bar.png": "5d31",
	"./icons/home.svg": "ac9d",
	"./icons/labour.svg": "c614",
	"./icons/labour2.svg": "1d60",
	"./icons/materials.svg": "6111",
	"./icons/materials2.svg": "c2b1",
	"./icons/milestones.svg": "0f11",
	"./icons/milestones2.svg": "59f4",
	"./icons/paid.svg": "2f6f",
	"./icons/paid2.svg": "95cf",
	"./icons/performance2.svg": "b992",
	"./icons/planning.svg": "001a",
	"./icons/planning2.svg": "5a66",
	"./icons/portfolio.svg": "48dd",
	"./icons/portfolio2.svg": "c52d",
	"./icons/portfolio3.svg": "2e43",
	"./icons/programs.svg": "1ba8",
	"./icons/programs2.svg": "e513",
	"./icons/programs3.svg": "42f5",
	"./icons/projects.svg": "18d6",
	"./icons/projects2.svg": "9e39",
	"./icons/projects3.svg": "2162",
	"./icons/resources.svg": "ede2",
	"./icons/resources2.svg": "09eb",
	"./icons/resources3.svg": "ec2b",
	"./icons/schedule.svg": "6b6f",
	"./icons/schedule2.svg": "2cb3",
	"./icons/schedule3.svg": "6af8",
	"./icons/structures.svg": "c740",
	"./icons/structures2.svg": "4136",
	"./icons/structures3.svg": "0db0",
	"./icons/wbs.svg": "a404",
	"./icons/wbs2.svg": "378d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36e7";